export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Nguyễn Minh Anh',
      role: 'Chuyên gia Marketing',
      avatar: 'https://public.readdy.ai/ai/img_res/9aff6d45954dc8752b4075e1d261819b.jpg',
      content: 'Trang thương hiệu cá nhân đã giúp tôi thu hút được nhiều khách hàng tiềm năng hơn. Thiết kế chuyên nghiệp và dễ sử dụng!',
      rating: 5
    },
    {
      name: 'Trần Hoàng Nam',
      role: 'Freelance Designer',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20male%20designer%20portrait%20smiling%20with%20creative%20workspace%20background%20confident%20freelancer%20in%20casual%20professional%20attire&width=200&height=200&seq=avatar-002&orientation=squarish',
      content: 'Đầu tư 70k cho trang cá nhân là quyết định đúng đắn nhất. Portfolio của tôi giờ trông thật ấn tượng và chuyên nghiệp.',
      rating: 5
    },
    {
      name: 'Lê Thị Hương',
      role: 'Giảng viên Yoga',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20female%20yoga%20instructor%20smiling%20portrait%20with%20peaceful%20studio%20background%20confident%20wellness%20coach%20in%20athletic%20wear&width=200&height=200&seq=avatar-003&orientation=squarish',
      content: 'Trang web giúp tôi giới thiệu lớp học và dịch vụ một cách chuyên nghiệp. Học viên mới tìm đến tôi dễ dàng hơn rất nhiều!',
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-amber-100 rounded-full mb-6">
            <i className="ri-chat-quote-line text-lg text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-700">Khách Hàng Nói Gì</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Câu Chuyện Thành Công<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-amber-600">
              Từ Khách Hàng
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Hàng trăm khách hàng đã tin tưởng và thành công với trang thương hiệu cá nhân của chúng tôi
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:border-gray-200 transition-all duration-300 hover:shadow-2xl"
            >
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-teal-500"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-amber-500"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.content}"
              </p>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-center gap-2 text-sm text-teal-600 font-semibold">
                  <i className="ri-checkbox-circle-fill"></i>
                  <span>Khách hàng đã xác thực</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-8 px-10 py-6 bg-gradient-to-r from-teal-50 to-amber-50 rounded-2xl border-2 border-teal-200">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-1">500+</div>
              <div className="text-sm text-gray-600">Khách hàng</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-amber-600 mb-1">4.9/5</div>
              <div className="text-sm text-gray-600">Đánh giá</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-rose-600 mb-1">98%</div>
              <div className="text-sm text-gray-600">Hài lòng</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}